/**
 *
 * @param {*} contract 获取装备，传装备合约equipContract；属性卡传cardContract
 * @returns
 */
//获取装备详情，通过equipId获取
import { ueContract, ueQuickContract } from "./useContract.js";
import {
  cardAddress,
  cardAbi,
  equipAddress,
  equipAbi,
  RunbitAbi,
  RunbitAddress,
  RunbitProxyAddress,
  RunbitProxyAbi,
} from "./address.js";
import { getBindCards } from "./useRunbit";

const runContractPromise = ueQuickContract(RunbitAddress, RunbitAbi);
const equipContractPromise = ueQuickContract(equipAddress, equipAbi);
const cardContractPromise = ueQuickContract(cardAddress, cardAbi);
const proxyContractPromise = ueQuickContract(
  RunbitProxyAddress,
  RunbitProxyAbi
);

function formatBigNumber(obj) {
  const copy = {};
  Object.keys(obj).forEach((key, index) => {
    copy[key] = obj[key] && obj[key].toNumber ? obj[key].toNumber() : obj[key];
  });
  return copy;
}
export async function getEquip(equipContract, equipId, account) {
  let equip = {};
  let copy = {};
  const e = equipContract.tokenMetaData(equipId);
  const uri = equipContract.tokenURI(equipId);
  const cards = getBindCards(equipId, account);
  return Promise.all([e, cards, uri]).then((results) => {
    let equipInfo = results[0];
    Object.keys(equipInfo).forEach((key, index) => {
      copy[key] =
        typeof equipInfo[key] == "number"
          ? equipInfo[key]
          : equipInfo[key].toNumber();
    });
    equip.equip = copy;
    equip.id = equipId.toNumber();
    equip.cards = results[1];

    equip.img = results[2];
    return equip;
  });
}

export async function getCard(runContract, cardContract, cardId) {
  let card = {};
  let copy = {};
  const cardInfo = cardContract.tokenMetaData(cardId);
  const status = runContract.getCardInfo(cardId);
  const consume = runContract.getCardConsume(cardId);
  const uri = cardContract.tokenURI(cardId);
  return Promise.all([cardInfo, status, consume, uri]).then((results) => {
    let e = results[0];

    Object.keys(e).forEach((key, index) => {
      copy[key] = typeof e[key] == "number" ? e[key] : e[key].toNumber();
    });
    card.card = copy;
    card.id = cardId.toNumber();
    card.status = results[1][0].toNumber();
    card.consume = results[2].toNumber();
    card.img = results[3];
    return card;
  });
}

export async function getMyCards(account) {
  return proxyContractPromise.then((contract) => {
    return contract.getAllCards(account).then((res) => {
      const r =  res.map((card) => {
        return {
          card:formatBigNumber(card.meta),
          id: card.id.toNumber(),
          status: card.info.equipId.toNumber(),
          consume: card.consume.toNumber(),
          img: card.uri,
          count: card.count.count.toNumber()
        }
      })
      console.log('getAllCards',res,r)
      return r;
    });
  });
}
//获取我的装备集合
export async function getMyEquips(account) {
  return await proxyContractPromise.then((contract) => {
    return contract.getAllEquips(account).then((res) => {
      const r = res.map((equip) => {
        return {
          equip: formatBigNumber(equip.meta),
          id: equip.id.toNumber(),
          img: equip.uri,
          latestDay: equip.info.latestDay,
          cards: equip.cards.map((e, i) => {
            if (e.toNumber()) {
              return { id: e.toNumber(), img: equip.cardURIs[i] };
            }
            return 0
          }),
        };
      });
      console.log("getAllEquips", res, r);
      return r;
    });
  });
}
//获取授权情况 tokenContract对operate授权的情况
export async function getNFTApprove(tokenContract, owner, operator) {
  return tokenContract.isApprovedForAll(owner, operator);
}
//授权 tokenContract对operate授权
export async function approveNFT(tokenContract, operate) {
  return tokenContract.setApprovalForAll(operate, true);
}
//转让
export async function transferNFT(ntfToken, from, to, nftId) {
  return ntfToken["safeTransferFrom(address,address,uint256)"](from, to, nftId);
}
